import React from 'react';
import { cn } from '@crabs-ai/ds-react';

export const CollapsibleContent: React.FC<{
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
}> = ({ isOpen, children, className }) => (
  <div
    className={cn(
      'grid transition-[grid-template-rows] duration-200 ease-in-out',
      isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
      className,
    )}
  >
    <div
      // 접힌 상태에서도 마운트는 유지되므로 inert 로 tab 포커스·클릭·스크린리더 노출을 차단
      inert={!isOpen}
      className={cn(
        'min-h-0 overflow-hidden transition-opacity duration-200 ease-in-out',
        isOpen ? 'opacity-100' : 'opacity-0',
      )}
    >
      {children}
    </div>
  </div>
);
